import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { CHUNK_RELOAD_KEY } from './chunkLoadErrorRecoveryScript';

/**
 * SPA 라우트 전환 중 ChunkLoadError 발생 시 페이지를 한 번 리로드하는 hook.
 * - routeChangeError에서 ChunkLoadError 감지 → URL당 1회 리로드
 * - routeChangeComplete에서 플래그 제거 (복구 성공 시 다음 에러에 다시 대응 가능)
 * - MPA 초기 로드 실패는 _document의 인라인 스크립트(chunkLoadErrorRecoveryScript)에서 처리
 */
export const useChunkLoadErrorHandler = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteError = (error: Error) => {
      if (error.name !== 'ChunkLoadError') {
        return;
      }

      try {
        const reloadedUrl = sessionStorage.getItem(CHUNK_RELOAD_KEY);
        if (reloadedUrl === window.location.href) {
          return;
        }

        sessionStorage.setItem(CHUNK_RELOAD_KEY, window.location.href);
        window.location.reload();
      } catch (e) {
        // sessionStorage 접근 불가 시 (cross-origin iframe 등) 무시
      }
    };

    const handleRouteComplete = () => {
      try {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      } catch (e) {
        // sessionStorage 접근 불가 시 무시
      }
    };

    router.events.on('routeChangeError', handleRouteError);
    router.events.on('routeChangeComplete', handleRouteComplete);

    return () => {
      router.events.off('routeChangeError', handleRouteError);
      router.events.off('routeChangeComplete', handleRouteComplete);
    };
  }, [router.events]);
};
